module.exports = __webpack_public_path__ + "img/suggestion-close.c7a31679.svg";